import Swal from 'sweetalert2';

/**
 * Uso en componentes (Options API):
 * this.$loading.show('Procesando...');
 * this.$loading.hide();
 * 
 * Uso en Composition API:
 * import { loading } from '@/plugins/loading';
 * loading.show();
 */

export const loading = {
  // Muestra la animación de carga
  show: (title = 'Cargando...') => {
    Swal.fire({
      title: title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  },
  // Modelo de animación alternativo (Minimalista/Custom)
  showCustom: (title = 'Por favor espere', text = 'Estamos procesando su solicitud') => {
    Swal.fire({
      title: title,
      html: `<div class="custom-loader-container">
               <p>${text}</p>
             </div>`,
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        popup: 'animated fadeInDown'
      }
    });
  },
  // Cierra la animación
  hide: () => {
    Swal.close();
  }
};

export default {
  install: (app) => {
    // Lo hace accesible globalmente como this.$loading y a través de provide
    app.config.globalProperties.$loading = loading;
    
    // Opcional: proveer para usar con inject() en Composition API
    app.provide('loading', loading);
  }
};